import { Component, OnInit } from '@angular/core';
import { Globals } from 'src/app/global';

@Component({
  selector: 'app-self-employed',
  templateUrl: './self-employed.component.html',
  styleUrls: ['./self-employed.component.scss']
})
export class SelfEmployedComponent implements OnInit {

  constructor(public globals: Globals) { }

  section_modal = '';

  ngOnInit() {
    const modal = this.globals.getModalValue();
    if (undefined !== modal) {
      this.section_modal = modal;
    }
  }

  setValue(value) {
    this.globals.setValue(value);
  }

}
